// Toggle collection description
let collectionDescription = document.querySelector('.collection-desc');
let collectionDescGhost = document.querySelector('.collection-desc-ghost');
let collectionDescBtn = document.querySelector('.collection-desc-toggle');

if (collectionDescription) {
  if( collectionDescGhost ) {
    const descriptionHeight = collectionDescGhost.clientHeight;
    if (descriptionHeight > 30) {
      collectionDescription.classList.add('collapsed');
      collectionDescBtn.style.display = 'inline-block';
      collectionDescBtn.onclick = function () {
        collectionDescBtn.classList.toggle('close');
        collectionDescription.classList.toggle('collapsed');
      }
    }
    // not sure why this was done like this, but since we're not using ghost after initial
    // assessment, we may as well delete it.
    // alternatively, we may want to keep it and do reassessment on resize/rotate
    collectionDescGhost.remove();
  }
  collectionDescription.style.display = 'block';
}
